import { BellOff, RotateCcw } from 'lucide-react'
import {
  useGetOccurrenceDetectorQuery,
  useGetCustomAgentTriggerStateQuery,
  useUpdateCustomAgentTriggerOccurrenceMutation,
  type WorkScope
} from '@axilon-apps/domains-ontology-ui-state'
import { Button } from '../ui/button'
import { WorkError } from './OccurrenceTasks'

export function OccurrenceSuppression({ scope, id }: { scope: WorkScope; id: string }) {
  const query = useGetOccurrenceDetectorQuery({ ...scope, id })
  // Failure cannot prove a safe detector target.
  const target = query.isError ? null : query.currentData?.target
  return target ? (
    <DetectorSuppression
      key={`${target.config_id}:${target.trigger_occurrence_id}`}
      configId={target.config_id}
      detectorId={target.trigger_occurrence_id}
    />
  ) : null
}
function DetectorSuppression({ configId, detectorId }: { configId: string; detectorId: string }) {
  const query = useGetCustomAgentTriggerStateQuery(
    { customAgentConfigId: configId },
    { refetchOnMountOrArgChange: true }
  )
  const [mutate, mutation] = useUpdateCustomAgentTriggerOccurrenceMutation()
  const occurrence = query.isError
    ? undefined
    : query.currentData?.occurrences.find((row) => row.id === detectorId)
  if (!occurrence || occurrence.cleared_at) return null
  const suppressed = occurrence.suppress_until_clear === true
  return (
    <>
      <Button
        size="xs"
        variant="outline"
        aria-pressed={suppressed}
        disabled={mutation.isLoading || query.isFetching}
        onClick={() =>
          void mutate({
            customAgentConfigId: configId,
            occurrenceId: detectorId,
            action: suppressed ? 'unsuppress' : 'suppress'
          })
        }
        className="h-7 text-st-elev"
      >
        {suppressed ? <RotateCcw size={14} /> : <BellOff size={14} />}
        {suppressed ? 'Unsuppress' : 'Suppress until clear'}
      </Button>
      {mutation.error && <WorkError message="Couldn't update suppression." />}
    </>
  )
}
